// extracted by mini-css-extract-plugin
module.exports = {"purchase-intention-detail":"purchase-intention-detail-1c9620821341e540b60fdfb07af4ee16"};